import { createClient } from "@supabase/supabase-js";

const env = import.meta.env as Record<string, string | undefined>;
const url = env.VITE_SUPABASE_URL;
const anonKey = env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Build doc §11.4 / §12.5 — anon key only on the client. Don't blow up in dev mode if missing
  // (Phase 0 ships before Supabase is provisioned), but log loudly so it can't ship to prod silently.
  console.warn(
    "[supabase] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY is missing. Auth and data calls will fail.",
  );
}

// Type annotation deferred until `pnpm db:gen-types` is run against a real
// Supabase project; then this will be `SupabaseClient<Database>` from
// @argus/shared-types/database.
export const supabase = createClient(
  url ?? "https://placeholder.supabase.co",
  anonKey ?? "placeholder",
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);
